export default __webpack_public_path__ + "static/media/step22.ee9ffd06.png";